var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73412 24C1.80078 24 1.13967 23.5667 0.750784 22.7C0.361895 21.8333 0.489673 21.0444 1.13412 20.3333L9.40078 11V2H7.66745C7.37856 2 7.13967 1.90556 6.95078 1.71667C6.76189 1.52778 6.66745 1.28889 6.66745 1C6.66745 0.711111 6.76189 0.472222 6.95078 0.283333C7.13967 0.0944446 7.37856 0 7.66745 0H18.3341C18.623 0 18.8619 0.0944446 19.0508 0.283333C19.2397 0.472222 19.3341 0.711111 19.3341 1C19.3341 1.28889 19.2397 1.52778 19.0508 1.71667C18.8619 1.90556 18.623 2 18.3341 2H16.6008V11L24.8674 20.3333C25.5119 21.0444 25.6397 21.8333 25.2508 22.7C24.8619 23.5667 24.2008 24 23.2674 24H2.73412ZM2.33412 22H23.6674L14.6008 11.7333V2H11.4008V11.7333L2.33412 22Z",
    fill: "#1C1C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.66dab73043907fe2b1afa09becdd632f.svg";
export { ForwardRef as ReactComponent };